import React from 'react';
import PropTypes from 'prop-types';

import styles from './PromotionalBanner.scss';
import CloseIcon from 'Static/icons/close-x.svg';
import ConnectedFormattedImage from 'Containers/ConnectedFormattedImage';

class PromotionalBanner extends React.PureComponent {
  render() {
    const {
      type,
      headline,
      description,
      closeHandler,
      ctaButton,
      hasGraphic,
      altId,
      visible,
    } = this.props;
    const graphic = hasGraphic ? require(`./graphic-${type}.png`) : null;

    if (!visible) return null;

    return (
      <div className={`PromotionalBanner PromotionalBanner--${type}`}>
        <div className="PromotionalBanner__container">
          <CloseIcon
            className="PromotionalBanner__close-button"
            onClick={closeHandler}
          />
          <h3 className="PromotionalBanner__headline">{headline}</h3>
          {description ? (
            <p className="PromotionalBanner__description">{description}</p>
          ) : null}
          {hasGraphic ? (
            <ConnectedFormattedImage
              src={graphic}
              altId={`promotional_banner.${type}.graphic_alt`}
              className="PromotionalBanner__graphic"
            />
          ) : null}
          {ctaButton}
        </div>
      </div>
    );
  }
}

PromotionalBanner.propTypes = {
  type: PropTypes.string.isRequired,
  closeHandler: PropTypes.func,
  headline: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  graphicId: PropTypes.string,
  ctaButton: PropTypes.element,
  hasGraphic: PropTypes.bool,
  visible: PropTypes.bool,
};

export default PromotionalBanner;
